import { posthogEventEmitter } from "./posthogEventEmitter";

let lastTrackedKey = "";

/**
 * Track SPA page views on route changes.
 * Deduplicates same route to prevent double-fires.
 *
 * @param screen - Route/module name (e.g. "dashboard", "leads", "campaigns")
 */
export default function trackRoutePageView(screen: string): void {
	if (typeof window === "undefined" || !screen) return;

	const page_path = window.location.pathname;
	const page_url = window.location.href;

	// Deduplicate same route
	const dedupeKey = `${screen}|${page_path}|${page_url}`;
	if (dedupeKey === lastTrackedKey) return;
	lastTrackedKey = dedupeKey;

	posthogEventEmitter({
		action: "page_viewed",
		category: "route",
		screen,
		page_path,
		page_url,
	});
}
